export const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_APP_KEY || '96516334cc18f1efbf0d';
export const PUSHER_APP_CLUSTER = process.env.REACT_APP_PUSHER_APP_CLUSTER || 'us2';
export const GLOBAL_STATUS_UPDATE_CHANNEL_PREFIX = 'accom_broadcast_';
export const GLOBAL_STATUS_UPDATE_CHANNEL_MESSAGE = 'update';
export const GLOBAL_APP_RELOAD_MESSAGE = 'PROMPT_APP_UPDATE';
export const API_RESPONSE_MESSAGE = 'APIResponse';



// WEBPACK FOOTER //
// ./src/constants/pusher.js